import $ from 'jquery';

import application from 'application/application';

application

	.factory('httpInterceptor', ['$q', 'API', 'authentication', 'helper', '$injector', ($q, API, authentication, helper, $injector) => {

		var ngNotify;

		const

			responseHook = response => {

				if (response.data) {

					let

						{ status, config, data } = response,

						shouldOverrideMessage = hasMessagesOverrides(response.config),

						hasMessage = data.status && data.status.mensagem,

						message = hasMessage ? data.status.mensagem : null;

					/** Verifica se a resposta é de erro. */
					if (/^2\d{2}$/.test(status)) {
						ngNotify = $injector.get('ngNotify');

						if (/^POST|PUT|DELETE/i.test(config.method) && hasMessage) {
							if (shouldOverrideMessage.success)
								config.messageOverride.success();

							else
								ngNotify.set(message, {
									type:'success',
									position: 'bottom'
								});
						}

					} else if (hasMessage) {
						ngNotify = $injector.get('ngNotify');

						if (status === 401 && authentication.isLogged())

							$('#modalQuickLogin').modal('show');

						if (Array.isArray(data.status.erros))

							message += data.status.erros.map(e => e.mensagem).join('');

						if (shouldOverrideMessage.error)
							config.messageOverride.error(response);

						else
							ngNotify.set(message, {
								type:'error',
								position: 'bottom'
							});

						return $q.reject(response);

					}

					return response;

				}

				if (response.config.timeout.canceled) return $q.reject('Canceled');

				ngNotify = $injector.get('ngNotify');

				ngNotify.set('Ocorreu um erro inesperado.', {
					type:'error',
					position: 'bottom'
				});

				return $q.reject(response);

			};

		return {
			request(config) {

				let currentAPIKey = Object.keys(API).find(key => key !== 'default' && helper.http(API[key], config.method, config.params).url === config.url);

				if (API.hasOwnProperty(currentAPIKey)) {

					let currentAPI = API[currentAPIKey];

					if (typeof currentAPI === 'object' && typeof currentAPI.hooks === 'object' && typeof currentAPI.hooks.request === 'function') {

						currentAPI.hooks.request(config);

					}

				}

				const re = new RegExp(Array.from(new Set(
					Object.keys(API).filter(key => key !== 'login' && key !== 'parceiros').map(value => {

						let { protocol, hostname, port } = { ...API.default, ...API[value] };

						return `^${protocol}\\/\\/${hostname.replace(/\./g, '\\.')}` + (port ? `:${port}`: '');
					})
				)).join('|'), 'i');

				const token = localStorage.getItem('__authenticationToken__');

				// const tokenType = localStorage.getItem('__authenticationTokenType__') || 'Bearer';

				if (token && re.test(config.url) && token != 'undefined')
					config.headers.Authorization = `Bearer ${token}`;

				return config;

			},
			response(response) {

				let

					config = response.config,

					currentAPIKey = Object.keys(API).find(key => key !== 'default' && helper.http(API[key], config.method, config.params).url === config.url);

				if (API.hasOwnProperty(currentAPIKey)) {

					let currentAPI = API[currentAPIKey];

					if (typeof currentAPI === 'object' && typeof currentAPI.hooks === 'object' && typeof currentAPI.hooks.response === 'function') {

						currentAPI.hooks.response(response);

					}

				}

				return responseHook(response);

			},
			responseError(rejection) {

				return responseHook(rejection);

			}
		};

	}]);


/* Verfica se a requisição (ou o objeto `config`) deseja sobrescrever a notificação da resposta da requisição. */

function hasMessagesOverrides(request) {
	const { success, error } = request.messageOverride || {};

	return {
		success: typeof success === 'function',
		error: typeof error === 'function'
	};
}
